<template>
  <div class="menu-mobile-app">
    <div class="menu-main-action">
      <a-button
        v-for="(menuChildItem, idx) in menuChildItems"
        :key="menuChildItem.type"
        :class="['menu-button', { active: type === idx }]"
        shape="round"
        @click="changeType(idx)"
        >{{ menuChildItem.title }}</a-button
      >
    </div>
    <template v-for="(menuChildItem, idx) in menuChildItems" >
      <div class="menu-main-content clearfix" :key="menuChildItem.idx" v-show="type === idx">
        <div class="menu-main-content-left float-left" v-show="menuChildItem.image">
          <img :src="menuChildItem.image" alt="" >
        </div>
        <div class="menu-main-content-right float-left text-center" v-show="menuChildItem.qrcode">
          <img :src="menuChildItem.qrcode" alt="">
          <p class="text-center" v-html="menuChildItem.description"></p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    menuChildItems: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      type: 0
    }
  },
  methods: {
    changeType (newType) {
      this.type = newType
    }
  }
}
</script>
